import React from 'react';
import { SecondaryButtonLightBg } from 'apps/sigma2-ui/src/components/SecondaryButtonLightBg';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export interface FilterCancelButtonProps {
  /**
   * Callback when the cancel button is clicked
   */
  onCancel: () => void;
}

export const FilterCancelButton = ({ onCancel }: FilterCancelButtonProps) => {
  const language = useLanguage();

  return (
    <SecondaryButtonLightBg
      onClick={onCancel}
      translatedContent={language.filterCancelButton()}
      disabled={false}
      className={'w-full'}
    />
  );
};
